import React, {Component} from 'react';
import AuthHelper from "../../../libraries/auth-helper";
import ChartTotalUsers from "./chart-total-users";
import ChartTickets from "./chart-tickets";
import ChartFulfillment from "./chart-fulfillment";
import ChartDevice from "./chart-device";
import ChartOld from "./chart-old";
import DashboardTotal from "./dashboard-total";

class ContentDashboard extends Component {

    constructor(props) {
        super(props);
        let profile = AuthHelper.getProfile()
        this.state = {
            role: profile.role["name"]
        }
    }

    render() {
        if (this.state.role === 'Super Admin' || this.state.role === 'Management') {
            return (
                <div>
                    <div className="row">
                        <div className="col-12">
                            <DashboardTotal/>
                            <div className='row'>
                                <div className='col-md-6 col-sm-12'>
                                    <ChartTotalUsers/>
                                </div>
                                <div className='col-md-6 col-sm-12'>
                                    <ChartDevice/>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-6 col-sm-12'>
                                    <ChartTickets/>
                                </div>
                                <div className='col-md-6 col-sm-12'>
                                    <ChartFulfillment/>
                                </div>
                            </div>
                            <ChartOld/>
                        </div>
                    </div>
                </div>
            )
        }

        if (this.state.role === 'Sales') {
            return (
                <div>
                    <div className="row">
                        <div className="col-md-10 col-lg-9">
                            <ChartFulfillment/>
                        </div>
                    </div>
                </div>
            )
        }
        if (this.state.role === 'Customer Support Rep') {
            return (
                <div>
                    <div className="row">
                        <div className="col-md-10 col-lg-9">
                            <ChartTickets/>
                        </div>
                    </div>
                </div>
            )
        }
        return false
    }
}

export default ContentDashboard;